import * as React from 'react';

import { PageContainerWithData } from './PageContainerWithData';
import { formDataApi } from '../../api/formDataApi';

export function PageContainer() {
  const { data: formData, isError } = formDataApi.endpoints.getForm.useQuery();

  if (!formData || isError) {
    // TODO: у нас его так и не появилось, мы не деградировали страницу и падали при попытке работы с объектными данными
    /** TODO если нет данных - выбросить экран ошибки */
    return null;
  }

  return <PageContainerWithData formData={formData} />;
}
